import * as zod from "zod";

export const loginCredentialsSchema = zod.object({
  username: zod.string(),
  password: zod.string(),
});
